module.exports = __webpack_public_path__ + "img/investment_failed.32ab13f5.svg";